import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import TranslationProvider from '../../../providers/TranslationProvider';
import { Label } from '../../Form';
import './AccountLabel.scss';

const AccountLabel = ({
  id,
  error,
  forInput,
  translationKey,
  children,
  required,
}) => (
  <Label
    id={id}
    className={cx({
      AccountLabel: true,
      AccountLabel__error: error,
    })}
    forInput={forInput}
    required={required}
  >
    <TranslationProvider translationKey={translationKey}>
      <span>
        {children}
      </span>
    </TranslationProvider>
  </Label>
);

AccountLabel.propTypes = {
  error: PropTypes.bool.isRequired,
  forInput: PropTypes.string,
  translationKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  required: PropTypes.bool,
};

AccountLabel.defaultProps = {
  forInput: null,
  id: null,
  required: false,
};

export default AccountLabel;
